/* @flow */
import actionTypes from '../actions/actionsFactory/types';
import feature from '../config/feature';

const { creditCardConfig } = feature;
const defaultCurrentList = {
  crypto: creditCardConfig.simplex.cryptoCoinList,
  fiat: creditCardConfig.simplex.fiatCoinList,
};

export const INITIAL_STATE = {
  quoteInfo: {},
  transactionDetail: {},
  simplexInitInfo: {
    opened: true,
  },
  simplexCurrencyList: defaultCurrentList,
  gatewayChannel: [],
};

const _handleCurrencyList = data => (data && data.crypto && data.fiat) ? ({
  crypto: data.crypto.split(','),
  fiat: data.fiat.split(','),
}) : defaultCurrentList;

export const reducer = (state: Object, action: Object) => {
  switch (action.type) {
    case actionTypes.GET_SIMPLEX_QUORE_SUCCESS:
      return { ...state, quoteInfo: action.data };
    case actionTypes.GET_SIMPLEX_QUORE_ERROR:
      return { ...state, quoteInfo: { error: true } };
    case actionTypes.SEND_PAYMENT_REQUEST_SUCCESS:
      return { ...state, transactionDetail: action.data };
    case actionTypes.CHECK_SIMPLEX_STATUS_SUCCESS:
      return { ...state, simplexInitInfo: action.data };
    case actionTypes.GET_SIMPLEX_CURRENCY_LIST_SUCCESS:
      return { ...state, simplexCurrencyList: _handleCurrencyList(action.data) };
    case actionTypes.GET_GATEWAY_CHANNEL_SUCCESS:
      return { ...state, gatewayChannel: action.data };
    case actionTypes.GET_GATEWAY_CHANNEL_ERROR:
      return { ...state, gatewayChannel: [] };
    default:
      return state;
  }
};

export type Quote = {
  userId?: string,
  quoteId?: string,
  walletId?: string,
  digitalCurrency?: string,
  digitalAmount?: string,
  fiatCurrency?: string,
  fiatBaseAmount?: string,
  fiatTotalAmount?: string,
  validUtil?: Date,
  error?: boolean,
};

export default {};
